module.exports = __webpack_public_path__ + "static/img/manual-52.5e099e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-52.png
// module id = r5f/
// module chunks = 4